import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  title: string;
}

const PageTitle: React.FC<Props> = (props) => {
  const { title } = props;

  return (
    <Box display="flex" justifyContent="center" marginY="22px">
      <Typography variant="h3" color="textPrimary">
        {title}
      </Typography>
    </Box>
  );
};

export default PageTitle;
